import { render, staticRenderFns } from "./select-user-region.vue?vue&type=template&id=681920ad"
import script from "./select-user-region.vue?vue&type=script&lang=ts"
export * from "./select-user-region.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports